import React from 'react';
import './Home.css';

// Import required components and constants
import { Button, CountdownTimer } from '../../../components';
import { home } from '../../../constants';



const Home = () => {

  return (
    <section className='home'>

      {/* Background image */}
      <img src={home.image} alt="Home-Pic" />

      {/* Content overlay */}
      <div className="content">
        <div className="text">

          <h5>{home.subtitle}</h5> {/* Subtitle text */}
          <h1>{home.headingPart1} <span>{home.spanText}</span> {home.headingPart2}</h1> {/* Main heading with a highlighted span */}
           {/*<CountdownTimer targetDate={new Date("2025-11-26T09:00:00")} />*/} {/* Countdown Timer component with a target date */}
          <Button link={home.buttonLink} title={home.buttonText} /> {/* Call to Action button */}

        </div>
      </div>

    </section>
  );
};

export default Home;